// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"88974660","361":"463319fc","503":"0bfb94c0","673":"b1465189","719":"37da4f5f","767":"8c4d2b25"}[chunkId] + ".chunk.js";
};